export const removePlusCode = (location) => {
  if (!location) {
    return '';
  }

  return location.replace(/\w{4,6}\+\w{2,4},? ?/g, '');
}